import { render } from "./OrderReceivePaymentModal.vue?vue&type=template&id=4dfd16a4&scoped=true"
import script from "./OrderReceivePaymentModal.vue?vue&type=script&lang=js"
export * from "./OrderReceivePaymentModal.vue?vue&type=script&lang=js"

import "./OrderReceivePaymentModal.vue?vue&type=style&index=0&id=4dfd16a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfd16a4"]])

export default __exports__